module.exports = __webpack_public_path__ + "static/img/uplatauloga2.0296fc3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kup/tutorial/uplatauloga2.png
// module id = AStN
// module chunks = 0